import React from 'react';
import styled from 'styled-components';


const Container = styled.div`
    position: ${props => props.style.position};
    top:${props => props.style.top};
    z-index:10000;
    display: flex;
    flex-direction: column;
    height:60px;
    align-items: center;
    justify-content: center;

    background: rgb(235, 250, 245);
    box-shadow: inset 0px -1px 0px 0px rgba(187, 195, 210, 0.5);
    border-radius: 0px;

    font-size:13px;
    color: rgb(57, 64, 71);

    .message {
        font-weight: 700;
    }

    a {
        color: #00B57A;
        text-decoration: underline;
    }

    .description{
        font-size:12px;
    }
`;

Container.defaultProps = {
  style: {
    position: "static",
    top: "auto"
  }
}

export function Banner({ message,cta, description, onClick, style }){
    return <Container style={style} >
                <div className="message"><span>{message}</span>{' '}<a onClick={onClick}>{cta}</a></div>
                <div className='description'>{description}</div>
        </Container>;
}
